export default {
  "reviews.title": "التقييمات",
  "reviews.subtitle": "اطّلع على تقييمات العملاء للمغسلة ومندوبيها",
  "reviews.demoNote": "هذه معاينة ببيانات تجريبية.",

  "reviews.tab.laundry": "تقييمات المغسلة",
  "reviews.tab.drivers": "تقييمات المندوبين",

  "reviews.overall.title": "التقييم العام للمغسلة",
  "reviews.overall.caption": "يمثل هذا الرقم متوسط تقييمات العملاء.",
  "reviews.overall.outOf": "من 5",
  "reviews.overall.reviewsCount": "عدد التقييمات",
  "reviews.overall.none": "لم تُقيّم بعد",

  "reviews.list.title": "تقييمات العملاء",
  "reviews.list.empty": "لا توجد تقييمات للمغسلة بعد",
  "reviews.list.emptyDesc": "ستظهر تقييمات العملاء هنا فور توفرها.",

  "reviews.card.noComment": "بدون تعليق",
  "reviews.card.showMore": "عرض المزيد",
  "reviews.card.showLess": "عرض أقل",
  "reviews.card.order": "رقم الطلب",
  "reviews.card.viewOrder": "عرض الطلب",

  "reviews.drivers.title": "مندوبو المغسلة",
  "reviews.drivers.col.name": "المندوب",
  "reviews.drivers.col.rating": "التقييم العام",
  "reviews.drivers.col.actions": "الإجراءات",
  "reviews.drivers.view": "عرض التقييمات",
  "reviews.drivers.notRated": "لم يُقيّم بعد",
  "reviews.drivers.count": "عدد التقييمات",
  "reviews.drivers.empty": "لا يوجد مندوبون تابعون للمغسلة",
  "reviews.drivers.emptyDesc": "ستظهر تقييمات المندوبين بعد إضافة حساباتهم.",

  "reviews.detail.title": "تقييمات {{name}}",
  "reviews.detail.back": "العودة إلى المندوبين",
  "reviews.detail.summary": "التقييم العام للمندوب",
  "reviews.detail.empty": "لا توجد تقييمات لهذا المندوب بعد",
  "reviews.detail.emptyDesc": "ستظهر تقييمات العملاء لهذا المندوب هنا فور توفرها.",

  "reviews.note": "التقييمات للعرض فقط، ومعالجة التقييمات المسيئة تتم من خلال الإدارة.",

  "reviews.error.laundry": "تعذّر تحميل تقييمات المغسلة",
  "reviews.error.drivers": "تعذّر تحميل تقييمات المندوبين",
  "reviews.error.detail": "تعذّر تحميل تقييمات المندوب",
  "reviews.notFound": "تعذّر العثور على المندوب",
  "reviews.notFoundBack": "العودة إلى التقييمات"
};